import { useEffect, useState } from 'react';
import { BASE_URL } from './conf/config';

// Whether the server runs on the demo data (made-up names, see backend demo.py) and has Superset (reports).
// Asked once per page load; `loaded` tells whether the answer is there yet.
let cached = null;

export function useInstance() {
  const [instance, setInstance] = useState(cached || { demo: false, loaded: false });
  useEffect(() => {
    if (cached) return;
    fetch(`${BASE_URL}/api/instance/`)
      .then((r) => (r.ok ? r.json() : { demo: false }))
      .catch(() => ({ demo: false }))
      .then((data) => { cached = { ...data, loaded: true }; setInstance(cached); });
  }, []);
  return instance;
}
